import { render, staticRenderFns } from "./CourseAudio.vue?vue&type=template&id=6e03b1bb&scoped=true&"
import script from "./CourseAudio.vue?vue&type=script&lang=js&"
export * from "./CourseAudio.vue?vue&type=script&lang=js&"
import style0 from "./CourseAudio.vue?vue&type=style&index=0&id=6e03b1bb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e03b1bb",
  null
  
)

component.options.__file = "CourseAudio.vue"
export default component.exports